import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=8bba7b0e"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports